import { render, staticRenderFns } from "./UsersDeleteDataRequestsHistory.vue?vue&type=template&id=61ec7550"
import script from "./UsersDeleteDataRequestsHistory.vue?vue&type=script&lang=js"
export * from "./UsersDeleteDataRequestsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports